<template>
    <div class="tw-px-8 tw-py-2">
        <Table
            :columns="columns"
            :data="row.accounts || []"
            size="small"
            :no-data-text="$t('bankProfile.noAccounts')"
        >
            <template slot-scope="{ row: account }" slot="employee">
                <span v-if="account.employee">
                    {{ account.employee.employee_name_en || account.employee.employee_name_kh }}
                </span>
                <span v-else class="tw-text-gray-300">—</span>
            </template>
            <template slot-scope="{ row: account }" slot="qr_image">
                <img
                    v-if="account.qr_image"
                    :src="account.qr_image"
                    class="tw-w-8 tw-h-8 tw-object-cover tw-rounded tw-border tw-border-gray-200 tw-mx-auto"
                />
                <span v-else class="tw-text-gray-300">—</span>
            </template>
        </Table>
    </div>
</template>

<script>
export default {
    name: "BankProfileTableExpand",
    props: {
        row: { type: Object, required: true }
    },
    computed: {
        columns() {
            return [
                {
                    title: this.$t("bankProfile.employeeId"),
                    slot: "employee",
                    minWidth: 180
                },
                {
                    title: this.$t("bankProfile.accountNo"),
                    key: "account_no",
                    minWidth: 160
                },
                {
                    title: this.$t("bankProfile.accountName"),
                    key: "account_name",
                    minWidth: 200
                },
                {
                    title: this.$t("bankProfile.qrImage"),
                    slot: "qr_image",
                    width: 80,
                    align: "center"
                },
                {
                    title: this.$t("bankProfile.isReceiveCashTransfer"),
                    key: "is_receive_cash_transfer",
                    width: 140,
                    align: "center",
                    render: (h, { row }) => h("i-switch", { props: { value: row.is_receive_cash_transfer, size: "small", disabled: true } })
                }
            ];
        }
    }
};
</script>
